import React, { PureComponent } from 'react';
import classNames from 'classnames';
import throttle from 'lodash/throttle';

import DisplayComponent from '../BaseComponents/DisplayComponent';
import Link from '../Link/Link';

import './PopLockSection.module.css';

const PopLockGroup = DisplayComponent(
  class PopLockGroup extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        lockedChild: null,
        lockedPosition: null
      };
      this.stickyContent = this.stickyContent.bind(this);
    }

    componentDidMount() {
      this.addListener();
    }

    addListener() {
      window.addEventListener('scroll', throttle(this.stickyContent, 50));
      window.addEventListener('resize', throttle(this.stickyContent, 50));
    }

    stickyContent() {
      const { children } = this.props;
      if (!children) {
        return;
      }
      if (this.state.lockedPosition !== null) {
        for (var i = 0; i <= 2; i++) {
          const index = this.state.lockedPosition + [0, 1, -1][i];
          const child = children[index];
          if (this.search(child, index)) {
            this.setState({
              lockedChild: child.props.pluginId,
              lockedPosition: index
            });
            return;
          }
        }
      } else {
        const index = children.length - 1;
        const child = children[index];
        if (this.search(child, index)) {
          this.setState({
            lockedChild: child.props.pluginId,
            lockedPosition: index
          });
          return;
        }
      }
      for (let index in children) {
        index = parseInt(index, 10);
        const child = children[index];
        if (this.search(child, index)) {
          this.setState({
            lockedChild: child.props.pluginId,
            lockedPosition: index
          });
          return;
        }
      }
      this.setState({
        lockedChild: null,
        lockedPosition: null
      });
    }

    search(child, index) {
      if (child) {
        const movingChild = child.props.children[1 - child.props.lockedItem];
        if (movingChild) {
          const movingChildElement = document.getElementById(
            movingChild.props.id
          );
          if (movingChildElement) {
            const movingRect = movingChildElement.getBoundingClientRect();
            if (movingRect.top <= 1 && movingRect.bottom > 1) {
              if (
                !(
                  index === this.props.children.length - 1 &&
                  movingRect.bottom < window.innerHeight
                )
              ) {
                return true;
              }
            }
          }
        }
      }
      return false;
    }

    render() {
      const { children, groupId, theme } = this.props;
      const childrenWithProps = React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          locked: child.props.pluginId === this.state.lockedChild,
          lastSection: index === children.length - 1
        })
      );

      const names = this.props.children;
      let navList = null;
      if (names) {
        navList = names.map((O, i) => {
          return (
            <Link
              key={i}
              to={`#${O.props.title.replace(/\s+/g, '-').toLowerCase()}`}
            >
              <p
                styleName={`li-active-${O.props.pluginId ===
                  this.state.lockedChild}`}
              >
                {O.props.title}
              </p>
            </Link>
          );
        });
      }
      return (
        <div
          id={groupId}
          styleName={classNames(
            'pop-lock-group',
            `pop-lock-${theme}`,
            `active-${this.state.lockedChild !== null}`,
            `mobile-nav-${this.props.mobileNav ? 'true' : 'false'}`
          )}
        >
          {childrenWithProps}
          <div
            styleName={classNames(
              'pop-nav',
              `in-view-${this.state.lockedChild !== null}`
            )}
          >
            {navList}
          </div>
        </div>
      );
    }
  }
);

export default PopLockGroup;
